import React from 'react';

const TideWidget = ({ level = "2.4m", status = "RISING" }) => {
  return (
    <div className="instrument-widget" style={{ position: 'relative' }}>
      <span style={{ position: 'absolute', top: '8px', left: '8px', fontSize: '14px' }}>🇵🇭</span>
      <div className="tide-icon">
        <div className={`wave ${status === 'RISING' ? 'rising' : 'falling'}`}></div>
      </div>
      <div className="counter-label">TIDE</div>
      <div className="status-tag tide-status">{level} {status}</div>
    </div>
  );
};

export default TideWidget;
